import { createUseStyles } from 'react-jss';
export default createUseStyles({
    container: {
        position: 'fixed',
        bottom: 0,
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(196, 196, 196, .8)',
        zIndex: 1002,
    },
    wrapper: {}
});
//# sourceMappingURL=styles.js.map